import { render, staticRenderFns } from "./SlotPanel.vue?vue&type=template&id=359a1a18"
import script from "./SlotPanel.vue?vue&type=script&lang=js"
export * from "./SlotPanel.vue?vue&type=script&lang=js"
import style0 from "./SlotPanel.vue?vue&type=style&index=0&id=359a1a18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
